import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { appStateActions } from 'store/appStateSlice';
import { adminActions } from 'features/admin/store/slice';
import { usePerformActionOnSuccess, useEditMode } from 'shared/hooks';
import { SuccessActionTypesEnum } from 'store/SuccessActionTypes.enum';

const useHl7PatientEdit = () => {
  const dispatch = useDispatch();
  const { hl7PatientId } = useParams();
  const { hl7Patient } = useSelector(({ admin }) => admin);
  const editMode = useEditMode();

  const fetchPatient = useCallback(() => {
    dispatch(adminActions.getHl7PatientById(hl7PatientId));
  }, [dispatch, hl7PatientId]);

  usePerformActionOnSuccess(SuccessActionTypesEnum.HL7_PATIENT_UPDATED, () => {
    dispatch(appStateActions.hideSnackbar());
    fetchPatient();
    editMode.disableEditMode();
  });

  const onPatientUpdate = (data) => {
    dispatch(
      adminActions.updateHl7Patient({
        id: hl7PatientId,
        ...data,
      }),
    );
  };

  const patientData = useMemo(
    () => (hl7PatientId === String(hl7Patient?.id) ? hl7Patient : {}),
    [hl7PatientId, hl7Patient],
  );

  return {
    hl7PatientId,
    patientData,
    fetchPatient,
    onPatientUpdate,
    ...editMode,
  };
};

export default useHl7PatientEdit;
